import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const pageMeta = {
  "/": {
    title: "ITI Jobs, NAPS & NATS Apprenticeships | ApprenticeWala",
    description: "Find ITI jobs, NAPS and NATS apprenticeship opportunities in India. ApprenticeWala supports ITI, Diploma, Degree and 12th-pass candidates exploring Apprenticeship India pathways.",
  },
  "/employers": {
    title: "Hire Apprentices for ITI Jobs & NAPS Roles | ApprenticeWala",
    description: "Share NAPS, NATS, apprenticeship and private ITI job requirements with ApprenticeWala and connect with skilled early-career candidates in India.",
  },
  "/blog": {
    title: "Apprenticeship India, NAPS, NATS & ITI Jobs Updates | ApprenticeWala",
    description: "Read practical updates about Apprenticeship India pathways, NAPS, NATS, ITI jobs, private jobs and career guidance for apprentices.",
  },
  "/gallery": {
    title: "ITI Apprenticeship Training Gallery | ApprenticeWala",
    description: "Explore ApprenticeWala moments from ITI training, apprenticeship learning and skilled career journeys across India.",
  },
  "/admin/login": { title: "ApprenticeWala | Admin Login", description: "Private ApprenticeWala content and job management workspace." },
  "/admin": { title: "ApprenticeWala | Admin Dashboard", description: "Private ApprenticeWala content and job management workspace." },
};

export default function PageTitle() {
  const { pathname: rawPathname } = useLocation();
  const pathname = rawPathname.replace(/\/+$/, "") || "/";

  useEffect(() => {
    const meta = pathname.startsWith("/jobs/")
      ? {
        title: "ITI Job & Apprenticeship Opportunity | ApprenticeWala",
        description: "Review this ITI job or apprenticeship opportunity, including NAPS, NATS, facilities and eligibility details on ApprenticeWala.",
      }
      : pathname.startsWith("/blog/")
      ? pageMeta["/blog"]
      : pageMeta[pathname] || { title: "ApprenticeWala", description: "ITI jobs, apprenticeship and skilled career opportunities in India." };
    document.title = meta.title;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.setAttribute("content", meta.description);
  }, [pathname]);

  return null;
}